<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>

        <span class="my-auto f16 fw-bold me-2"> 
            
            {{ bUser_Biorhythm ? 'بیوریتم راننده' : 'بیوریتم رانندگان'  }} 
        
        </span>

    </div>

</div>


<ng-container *ngIf="bUser_Biorhythm;else isAllDrivers">

    <main style="direction: rtl;" class="d-flex justify-content-center align-items-center w-100 h-100 ">

        <div class="container biorhythm  w-100 p-4 h-100">

            <div class="Analysis container  w-100  mb-2" *ngFor="let item of biorhythmData">

                <div [innerHTML]="item.Introduction"></div>

                <div echarts [options]="options" class="container charts-container w-100 h-50 mb-2"></div>

                <div class="biorhythm-description" *ngIf="item.Analysis != '' ">

                    <div [innerHTML]="item.Analysis"></div>

                </div>

                <div class="biorhythm-description" *ngIf="item.Critical != '' ">

                    <div class="critical-container" [innerHTML]="item.Critical"></div>

                </div>

                <div class="biorhythm-description" *ngIf="item.Suggestion != '' ">

                    <div [innerHTML]="item.Suggestion"></div>

                </div>

            </div>

            <div echarts [options]="lineBar" class="container charts-container  w-100 h-50 mb-2"></div>

            <br>

        </div>

    </main>

</ng-container>

<ng-template #isAllDrivers>

    <main style="direction: rtl;" class="px-2">

        <div class="border border-2 mt-3 p-2">
    
            <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">
        
            <div class="section border border-2 mt-2" style="height:calc(100vh - 127px);overflow: auto;">
        
                <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        
                    <thead>
        
                        <tr class="">
        
                            <th class="text-center col-1"> # </th>
        
                            <th class="text-center"> عملیات </th>
        
                            <th class="text-center"> نام و نام&zwnj;خانوادگی </th>
    
                            <th class="text-center"> کد پرسنلی </th>
    
                            <th class="text-center"> شماره موبایل </th>
    
                            <th class="text-center"> پلاک خودرو </th>
    
                            <th class="text-center"> نوع خودرو </th>
    
                            <th class="text-center"> تاریخ تولد </th>
        
                        </tr>
        
                    </thead>
        
                    <tbody>
        
                        <tr *ngFor="let item of list_Drivers;let i = index" class="col-12 text-center">
    
                            <th> {{ i + 1 | faNum }} </th>
    
                            <th class="">
    
                                <i class="fa fa-eye fa-lg pointer" title="مشاهده اطلاعات" (click)="show_Info(item)"></i>
    
                                <i class="fa fa-line-chart text-success fa-lg mx-3 pointer" title="بیوریتم" (click)="show_Biorhythm(item,i)"></i>
    
                            </th>
    
                            <td>{{ item.strFullName | faNum }}</td>
                            
                            <td>{{ item.strPersonnelID | faNum }}</td>
    
                            <td>{{ item.strMobile | faNum }}</td>
    
                            <td>{{ item.strVehicleNo | faNum }}</td>
    
                            <td>{{ item.strGPSType_strComment | faNum }}</td>
    
                            <td>{{ item.strBirthDate | faNum }}</td>
        
                        </tr>
        
                    </tbody>
        
                </table>
        
            </div>
        
        </div>
    
    </main>

    <!-- دریافت تاریخ تولد -->
    
    <div class="modal fade" id="Biorhythm_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

        <div class="modal-dialog">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel"> ثبت تاریخ تولد راننده </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body px-3" [formGroup]="mdl_Search">

                    <p class="mb-3">برای مشاهده <strong>بیوریتم</strong> , تاریخ تولد راننده الزامی می باشد.</p>
    
                    <div class="mt-2 col-6 position-relative">
    
                        <label style="top: -9px;"> تاریخ تولد </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                            [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input formControlName="strBirthDate" class="form-control text-end" />
            
                        </ng-persian-datepicker>
            
                    </div>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">
    
                    <button class="btn btn-success" (click)="submit_BirthDate()">
    
                        &nbsp; &nbsp; ثبت &nbsp; &nbsp;
    
                    </button>
    
    
                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

    <!-- اطلاعات راننده -->

    <div class="modal fade" id="Info_Modal"  aria-hidden="true">

        <div class="modal-dialog modal-lg" style="direction: rtl;">
    
            <div class="modal-content">

                <div class="modal-header ">
    
                    <h5 class="modal-title" id="exampleModalLabel"> مشخصات راننده </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>

                <div class="modal-body">

                    <div class="container-fluid row gx-2 gy-2 p-2">

                        <!-- نام و نام خانوادگی -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">نام و نام&zwnj;خانوادگی</label>
                
                            <input class="form-control p-2 text-center" [value]="obj_Driver.strFullName" disabled>
                
                        </div>

                        <!-- شماره موبایل -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">شماره موبایل</label>
                
                            <input class="form-control p-2 text-center" [value]="obj_Driver.strMobile" disabled>
                
                        </div>

                        <!-- تاریخ تولد -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">تاریخ تولد</label>
                
                            <input class="form-control p-2 text-center" [value]="obj_Driver.strBirthDate" disabled>
                
                        </div>

                        <!-- نوع خودرو -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">نوع خودرو</label>
                
                            <input class="form-control p-2 text-center" [value]="obj_Driver.strGPSType_strComment" disabled>
                
                        </div>

                        <!-- نوع ردیاب -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">نوع ردیاب</label>
                
                            <input class="form-control p-2 text-center" [value]="obj_Driver.strGPS_strComment" disabled>
                
                        </div>

                        <!-- حوزه خدمت -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">حوزه خدمت</label>
                
                            <input class="form-control p-2 text-center" [value]="obj_Driver.strMobileDomain_strComment" disabled>
                
                        </div>

                        <!-- وضعیت -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">وضعیت</label>
                
                            <input class="form-control p-2 text-center" [value]="obj_Driver.strOfficialStatus_strComment" disabled>
                
                        </div>

                        <!-- شماره پرسنلی -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">شماره پرسنلی</label>
                
                            <input class="form-control p-2 text-center" [value]="obj_Driver.strPersonnelID" disabled>
                
                        </div>

                        <!-- تاریخ اعتبار -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">تاریخ اعتبار</label>
                
                            <input class="form-control p-2 text-center" [value]="obj_Driver.strValidDate" disabled>
                
                        </div>
                
                    </div>

                </div>

                <div class="modal-footer d-flex justify-content-start">
    
                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>

            </div>

        </div>

    </div>


</ng-template>

